<template>
  <div class="container mx-auto h-auto flex-col flex md:justify-between laptop:justify-center relative">
    <div class="z-20 p-1 px-5 laptop:ml-12 fullhd:ml-0 md:p-5 laptop:p-0">
      <MARSHeading>
        <slot name="title" />
      </MARSHeading>
      <slot name="cta" />
    </div>
    <div class="w-full flex content-end justify-end">
      <img class="block" style="width:auto !important;align-self: flex-start;" :src="imageUrlBelow">
    </div>
    <div class="z-20 p-1 px-5 laptop:ml-12 fullhd:ml-0 md:p-5 laptop:p-0">
      <slot name="footer" />
    </div>
    <div v-if="scrollIndicator" class="w-16 h-16 hidden laptop:block absolute bottom-0 mb-6 left-1/2 -ml-8 z-20">
      <img class="mx-auto" src="~/assets/img/scroll-down-gif.gif" alt="Scroll down indicator">
    </div>
  </div>
</template>

<script lang="ts">
import MARSHeading from '@/components/MARSHeading.vue'
export default defineNuxtComponent({
  name: 'Block01',
  components: { MARSHeading },
  props: {
    imageUrlRight: { type: String, default: null },
    imageUrlBelow: { type: String, default: null },
    scrollIndicator: { type: Boolean, default: false }
  }
})
</script>

<style scoped>

</style>
